export enum Feature {
    DevPortal = 'DevPortal',
    ReportingDashboard = 'ReportingDashboard',
    BulkPlanningJobSheet = 'BulkPlanningJobSheet',
    SimpleListItem = 'SimpleListItem',
}
